module.exports = __webpack_public_path__ + "static/img/14areaA_6.24b9f8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/14areaA_6.png
// module id = 1019
// module chunks = 1